// extracted by mini-css-extract-plugin
export default {"container":"VPos5d","floatingText":"O3PHMq"};